import { subDays } from 'date-fns';
import { Photo } from '../../../../components/PhotoGallery/interfaces';
import { RankingItem } from '@pages/Portal/Competitions/components/RankingTable/interfaces';

export const photos: Photo[] = [
  {
    title: 'Foto 1',
    source: '/dummy/competitions/comp1.jpg',
    date: new Date(),
  },
  {
    title: 'Foto 2',
    source: '/dummy/competitions/comp2.jpg',
    date: new Date(),
  },
  {
    title: 'Foto 3',
    source: '/dummy/competitions/comp3.jpg',
    date: new Date(),
  },
  {
    title: 'Foto 4',
    source: '/dummy/competitions/comp4.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 5',
    source: '/dummy/competitions/comp5.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 6',
    source: '/dummy/competitions/comp6.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 7',
    source: '/dummy/competitions/comp7.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 8',
    source: '/dummy/competitions/comp8.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 9',
    source: '/dummy/competitions/comp9.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 10',
    source: '/dummy/competitions/comp1.jpg',
    date: subDays(new Date(), 2),
  },
  {
    title: 'Foto 11',
    source: '/dummy/competitions/comp2.jpg',
    date: subDays(new Date(), 4),
  },
  {
    title: 'Foto 12',
    source: '/dummy/competitions/comp3.jpg',
    date: subDays(new Date(), 4),
  },
  {
    title: 'Foto 13',
    source: '/dummy/competitions/comp4.jpg',
    date: subDays(new Date(), 4),
  },
  {
    title: 'Foto 14',
    source: '/dummy/competitions/comp5.jpg',
    date: subDays(new Date(), 4),
  },
  {
    title: 'Foto 15',
    source: '/dummy/competitions/comp6.jpg',
    date: subDays(new Date(), 6),
  },
  {
    title: 'Foto 16',
    source: '/dummy/competitions/comp7.jpg',
    date: subDays(new Date(), 6),
  },
  {
    title: 'Foto 17',
    source: '/dummy/competitions/comp8.jpg',
    date: subDays(new Date(), 6),
  },
  {
    title: 'Foto 18',
    source: '/dummy/competitions/comp9.jpg',
    date: subDays(new Date(), 6),
  },
];

export const rankingData: RankingItem[] = [
  {
    rank: 1,
    name: 'Jaap Hardeman',
    avatarSource: '/dummy/avatars/SVDR/jaap.jpg',
    weaponGroups: [],
    totalSubmitted: 14,
    totalScore: 299.6,
    positionChange: 'up',
  },
  {
    rank: 2,
    name: 'Willem Swart',
    avatarSource: '/dummy/avatars/SVDR/willem.jpg',
    weaponGroups: [],
    totalSubmitted: 19,
    totalScore: 297.2,
    positionChange: 'same',
  },
  {
    rank: 3,
    name: 'Theo van der Veer',
    avatarSource: '/dummy/avatars/SVDR/theo.jpg',
    weaponGroups: [],
    totalSubmitted: 18,
    totalScore: 295.6,
    positionChange: 'down',
  },
  {
    rank: 4,
    name: 'Wendy Burggraaf',
    avatarSource: '/dummy/avatars/SVDR/wendy.jpg',
    weaponGroups: [],
    totalSubmitted: 17,
    totalScore: 293.4,
    positionChange: 'up',
  },
  {
    rank: 5,
    name: 'Gianfranco Storoni',
    avatarSource: '/dummy/avatars/SVDR/gianfranco.jpg',
    weaponGroups: [],
    totalSubmitted: 16,
    totalScore: 291.8,
    positionChange: 'down',
  },
  {
    rank: 6,
    name: 'Marjan de Winter',
    avatarSource: '/dummy/avatars/SVDR/marjan.jpg',
    weaponGroups: [],
    totalSubmitted: 15,
    totalScore: 289.9,
    positionChange: 'same',
  },
  {
    rank: 7,
    name: 'Jan Tybout',
    avatarSource: '/dummy/avatars/SVDR/jan.jpg',
    weaponGroups: [],
    totalSubmitted: 14,
    totalScore: 288.7,
    positionChange: 'up',
  },
  {
    rank: 8,
    name: 'Rianne Hogervorst',
    avatarSource: '/dummy/avatars/SVDR/rianne.jpg',
    weaponGroups: [],
    totalSubmitted: 4,
    totalScore: 287.5,
    positionChange: 'same',
  },
  {
    rank: 9,
    name: 'Eva de Boer',
    avatarSource: '/dummy/avatars/avatar9.jpg',
    weaponGroups: [],
    totalSubmitted: 12,
    totalScore: 286.9,
    positionChange: 'down',
  },
  {
    rank: 10,
    name: 'Rik Mulder',
    avatarSource: '/dummy/avatars/avatar10.jpg',
    weaponGroups: [],
    totalSubmitted: 11,
    totalScore: 285.8,
    positionChange: 'up',
  },
  {
    rank: 11,
    name: 'Sophie de Graaf',
    avatarSource: '/dummy/avatars/avatar11.jpg',
    weaponGroups: [],
    totalSubmitted: 10,
    totalScore: 284.6,
    positionChange: 'same',
  },
  {
    rank: 12,
    name: 'Jasper van der Meer',
    avatarSource: '/dummy/avatars/avatar12.jpg',
    weaponGroups: [],
    totalSubmitted: 9,
    totalScore: 283.9,
    positionChange: 'up',
  },
  {
    rank: 13,
    name: 'Emma Verhoeven',
    avatarSource: '/dummy/avatars/avatar13.jpg',
    weaponGroups: [],
    totalSubmitted: 8,
    totalScore: 282.7,
    positionChange: 'down',
  },
  {
    rank: 14,
    name: 'Daan Kuiper',
    avatarSource: '/dummy/avatars/avatar14.jpg',
    weaponGroups: [],
    totalSubmitted: 7,
    totalScore: 281.5,
    positionChange: 'same',
  },
  {
    rank: 15,
    name: 'Lotte Meijer',
    avatarSource: '/dummy/avatars/avatar15.jpg',
    weaponGroups: [],
    totalSubmitted: 6,
    totalScore: 280.9,
    positionChange: 'up',
  },
  {
    rank: 16,
    name: 'Tim Bakker',
    avatarSource: '/dummy/avatars/avatar16.jpg',
    weaponGroups: [],
    totalSubmitted: 5,
    totalScore: 279.8,
    positionChange: 'same',
  },
  {
    rank: 17,
    name: 'Isabella Dekker',
    avatarSource: '/dummy/avatars/avatar17.jpg',
    weaponGroups: [],
    totalSubmitted: 5,
    totalScore: 278.6,
    positionChange: 'down',
  },
  {
    rank: 18,
    name: 'Finn van Leeuwen',
    avatarSource: '/dummy/avatars/avatar18.jpg',
    weaponGroups: [],
    totalSubmitted: 4,
    totalScore: 277.9,
    positionChange: 'up',
  },
  {
    rank: 19,
    name: 'Sanne Smits',
    avatarSource: '/dummy/avatars/avatar19.jpg',
    weaponGroups: [],
    totalSubmitted: 4,
    totalScore: 276.8,
    positionChange: 'same',
  },
  {
    rank: 20,
    name: 'Noah de Wit',
    avatarSource: '/dummy/avatars/avatar20.jpg',
    weaponGroups: [],
    totalSubmitted: 3,
    totalScore: 275.5,
    positionChange: 'up',
  },
  {
    rank: 21,
    name: 'Liam Hoekstra',
    avatarSource: '/dummy/avatars/avatar21.jpg',
    weaponGroups: [],
    totalSubmitted: 3,
    totalScore: 274.7,
    positionChange: 'down',
  },
  {
    rank: 22,
    name: 'Olivia Gerritsen',
    avatarSource: '/dummy/avatars/avatar22.jpg',
    weaponGroups: [],
    totalSubmitted: 2,
    totalScore: 273.4,
    positionChange: 'same',
  },
  {
    rank: 23,
    name: 'Milan Vos',
    avatarSource: '/dummy/avatars/avatar23.jpg',
    weaponGroups: [],
    totalSubmitted: 2,
    totalScore: 272.6,
    positionChange: 'up',
  },
  {
    rank: 24,
    name: 'Zoë Willems',
    avatarSource: '/dummy/avatars/avatar24.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 271.8,
    positionChange: 'same',
  },
  {
    rank: 25,
    name: 'Nathan van Dam',
    avatarSource: '/dummy/avatars/avatar25.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 270.9,
    positionChange: 'up',
  },
  {
    rank: 26,
    name: 'Julia Hendriks',
    avatarSource: '/dummy/avatars/avatar26.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 269.7,
    positionChange: 'down',
  },
  {
    rank: 27,
    name: 'Benjamin van Rijn',
    avatarSource: '/dummy/avatars/avatar27.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 268.5,
    positionChange: 'same',
  },
  {
    rank: 28,
    name: 'Elise de Koning',
    avatarSource: '/dummy/avatars/avatar28.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 267.6,
    positionChange: 'up',
  },
  {
    rank: 29,
    name: 'David de Lange',
    avatarSource: '/dummy/avatars/avatar29.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 266.4,
    positionChange: 'same',
  },
  {
    rank: 30,
    name: 'Iris Jacobs',
    avatarSource: '/dummy/avatars/avatar30.jpg',
    weaponGroups: [],
    totalSubmitted: 1,
    totalScore: 265.1,
    positionChange: 'down',
  },
];
